/**
 * HeaderPinnedModules — Emoji buttons for pinned modules in the header.
 * Only renders if placement is 'header' or 'both'. Max 3 shown.
 */

import { useNavigate } from "react-router-dom";
import { cn } from "@/lib/utils";
import { usePinnedModules } from "@/hooks/usePinnedModules";
import { useModuleUnlock } from "@/hooks/useModuleUnlock";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const MAX_HEADER_PINS = 3;

export function HeaderPinnedModules() {
  const navigate = useNavigate();
  const { pinnedModules, placement } = usePinnedModules();
  const { moduleStates } = useModuleUnlock();

  if (placement === "sidebar") return null;
  if (pinnedModules.length === 0) return null;

  const visible = pinnedModules.slice(0, MAX_HEADER_PINS);

  return (
    <TooltipProvider delayDuration={200}>
      <div className="flex items-center gap-1">
        {visible.map((mod) => {
          const state = moduleStates[mod.id];
          const locked =
            state?.status === "locked" || state?.status === "coming_soon";

          return (
            <Tooltip key={mod.id}>
              <TooltipTrigger asChild>
                <button
                  onClick={() => !locked && navigate(mod.route)}
                  className={cn(
                    "flex h-8 w-8 items-center justify-center rounded-full bg-muted text-sm transition-colors",
                    locked
                      ? "opacity-50 cursor-not-allowed"
                      : "hover:bg-muted/80 cursor-pointer"
                  )}
                  aria-label={locked ? `${mod.name} — verrouillé` : mod.name}
                >
                  {mod.emoji}
                </button>
              </TooltipTrigger>
              <TooltipContent side="bottom" className="text-xs">
                {locked ? "Module verrouillé" : mod.name}
              </TooltipContent>
            </Tooltip>
          );
        })}
      </div>
    </TooltipProvider>
  );
}
